var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icon_email_24x24"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 45",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 10.0606V18.1419C22 18.6539 21.8039 19.0912 21.4108 19.4547C21.0178 19.8182 20.5465 20 19.9961 20H4.00388C3.45423 20 2.98218 19.8182 2.58917 19.4547C2.19687 19.0912 2 18.6539 2 18.1419V10.0606L12.0194 14.1818L22 10.0606ZM22 8.80827L12.0194 12.9701L2 8.80827V5.85888C2 5.34688 2.19687 4.90876 2.58917 4.54525C2.98218 4.18175 3.45423 4 4.00388 4H19.9961C20.5465 4 21.0178 4.18175 21.4108 4.54525C21.8039 4.90876 22 5.34688 22 5.85888V8.80827Z",
  fill: "#4585FF"
}))));
export default SvgIconEmail;